/** @format */

import React, { Component, Fragment } from 'react';
import ClientQuickSearch from '../../../Clients/ClientQuickSearch/ClientQuickSearch';
import ClientQuickCreate from '../../../Clients/ClientQuickCreate/ClientQuickCreate';
import ClientMiniOverview from '../../../Clients/ClientMiniOverview/ClientMiniOverview';
import { Divider } from 'semantic-ui-react';

import { inject, observer } from 'mobx-react';

@inject()
@inject('UserStore', 'ClientsStore')
@observer
class RequestClient extends Component {
  renderClient = () => {
    const { ClientsStore } = this.props;
    if (!ClientsStore.clientsParams.clientLoaded) {
      return (
        <div>
          <ClientQuickSearch />
          <Divider horizontal>
            <small>Oppure</small>
          </Divider>
          <ClientQuickCreate />
        </div>
      );
    } else {
      return <ClientMiniOverview buttons={true} />;
    }
  };
  render() {
    const { UserStore } = this.props;
    return !UserStore.user.isExternal ? (<div>{this.renderClient()}</div>) : (<Fragment></Fragment>);
  }
}

export default RequestClient;
